import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "frame"]
  static values = { url: String }

  open(event) {
    event.preventDefault()

    const form = document.getElementById("settings-form")
    if (!form) return

    const params = new URLSearchParams()
    new FormData(form).forEach((value, key) => {
      params.set(key, value)
    })

    const src = params.toString() ? `${this.urlValue}?${params.toString()}` : this.urlValue
    this.frameTarget.src = src
    this.panelTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
  }

  close(event) {
    if (event) event.preventDefault()
    this.panelTarget.classList.add("hidden")
    this.frameTarget.src = "about:blank"
    document.body.style.overflow = ""
  }
}
